import angular from 'angular';
import { build } from '@updater-components/footer';

export default angular.module('app.footer', []).component('appFooter', {
  template: '<div id="mover-app-footer"></div>',
  controller: ($element, $scope, appShell) => {
    'ngInject';
    const container = $element[0].querySelector('#mover-app-footer');
    const interactors = appShell.interactors;
    const { destroy } = build({ interactors, container });
    $scope.$on('$destroy', destroy);
  },
});
